export default "__VITE_ASSET__BTKdLV7o__"